<h1>{{data.title}}</h1>
<div>
  {{data.description}}
</div>
<div class="btn-container">
  <button (click)="cancel()"
          color="warn"
          mat-raised-button>{{data.cancel}}</button>
  <button (click)="confirm()"
          color="accent"
          mat-raised-button>{{data.confirm}}</button>

</div>
